/* eslint-disable no-underscore-dangle */

import React from 'react'
import ReactHtmlParser from 'react-html-parser'
import { FormatNumber, formatDateLocalized } from '../utils'

export type RatableDetailsItemProps = {
  amount: number
  couponRate: string
  currency: string
  dealReviewDate: string
  exemption: string
  language: string
  longTermSecurityRating: string
  longTermSecurityRatingAlertCode: string
  market: string
  maturityDate: string
  placement: string
  program: string
  commercialPaperType: string
  size: number
  ratableTypeDescription: string
  recoveryEstimate: string
  shortTermSecurityRating: string
  shortTermSecurityRatingAlertCode: string
}

export type RatableDetailsCell = {
  cellProps: any
}
const dateFormat = 'dd-MMM-yyyy'

export const ratableDetailsFilter = (filterItem: any, data: any) => {
  const filter = filterItem.value.toLowerCase()
  const {
    amount,
    couponRate,
    currency,
    dealReviewDate,
    exemption,
    language,
    longTermSecurityRating,
    market,
    maturityDate,
    placement,
    program,
    commercialPaperType,
    size,
    recoveryEstimate,
    shortTermSecurityRating
  }: RatableDetailsItemProps = data._original

  let result = false
  const amountFil =
    amount &&
    (FormatNumber(amount).toString().includes(filter) ||
      amount.toString().includes(filter))
  const couponRateFil = couponRate && couponRate.toLowerCase().includes(filter)
  const currencyFil = currency && currency.toLowerCase().includes(filter)
  const dealReviewDateFil =
    dealReviewDate &&
    formatDateLocalized(dealReviewDate, dateFormat, language)
      .toLowerCase()
      .toString()
      .includes(filter)
  const exemptionFil = exemption && exemption.toLowerCase().includes(filter)
  const marketFil = market && market.toLowerCase().includes(filter)
  const maturityDateFil =
    maturityDate &&
    formatDateLocalized(maturityDate, dateFormat, language)
      .toLowerCase()
      .toString()
      .includes(filter)
  const placementFil = placement && placement.toLowerCase().includes(filter)
  const programFil = program && program.toLowerCase().includes(filter)
  const commercialPaperTypeFil =
    commercialPaperType && commercialPaperType.toLowerCase().includes(filter)
  const sizeFil =
    size &&
    (FormatNumber(size).toString().includes(filter) ||
      size.toString().includes(filter))
  const recoveryEstimateFil =
    recoveryEstimate && recoveryEstimate.toLowerCase().includes(filter)
  const longTermSecurityRatingFil =
    longTermSecurityRating &&
    longTermSecurityRating.toLowerCase().includes(filter)
  const shortTermSecurityRatingFil =
    shortTermSecurityRating &&
    shortTermSecurityRating.toLowerCase().includes(filter)
  if (
    amountFil ||
    couponRateFil ||
    currencyFil ||
    dealReviewDateFil ||
    exemptionFil ||
    marketFil ||
    maturityDateFil ||
    placementFil ||
    programFil ||
    commercialPaperTypeFil ||
    sizeFil ||
    recoveryEstimateFil ||
    longTermSecurityRatingFil ||
    shortTermSecurityRatingFil
  ) {
    result = true
  }
  return result
}

export const RatableDetailsCell = (props: RatableDetailsCell) => {
  const { cellProps } = props
  const {
    amount,
    couponRate,
    currency,
    dealReviewDate,
    exemption,
    language,
    longTermSecurityRating,
    longTermSecurityRatingAlertCode,
    market,
    maturityDate,
    placement,
    program,
    commercialPaperType,
    size,
    ratableTypeDescription,
    recoveryEstimate,
    shortTermSecurityRating,
    shortTermSecurityRatingAlertCode
  }: RatableDetailsItemProps = cellProps.original

  const isLongTermSecRatAlertCode = `${
    longTermSecurityRatingAlertCode
      ? `<span class=${longTermSecurityRatingAlertCode.replace(
          ':',
          ''
        )}></span>`
      : ''
  }`
  const isShortTermSecRatAlertCode = `${
    shortTermSecurityRatingAlertCode
      ? `<span class=${shortTermSecurityRatingAlertCode.replace(
          ':',
          ''
        )}></span>`
      : ''
  }`
  return (
    <>
      {program && ReactHtmlParser(`<strong>Program:</strong> ${program}<br />`)}
      {commercialPaperType &&
        ReactHtmlParser(`<strong>Type:</strong> ${commercialPaperType}<br />`)}
      {maturityDate &&
        ReactHtmlParser(
          `<strong>Maturity Date:</strong> ${formatDateLocalized(
            maturityDate,
            dateFormat,
            language
          )} <br />`
        )}
      {currency &&
        ReactHtmlParser(`<strong>Currency:</strong> ${currency}<br />`)}
      {market && ReactHtmlParser(`<strong>Market:</strong> ${market}<br />`)}
      {size !== 0 &&
        ratableTypeDescription &&
        ratableTypeDescription.toLowerCase() === 'commercial paper' &&
        ReactHtmlParser(`<strong>Size: </strong>${FormatNumber(size)} <br />`)}
      {amount !== 0 &&
        ratableTypeDescription !== 'commercial paper' &&
        ReactHtmlParser(
          `<strong>Amount: </strong>${FormatNumber(amount)} <br />`
        )}
      {couponRate &&
        ReactHtmlParser(`<strong>Coupon Rate:</strong>  ${couponRate} <br />`)}
      {dealReviewDate &&
        ReactHtmlParser(
          `<strong>Deal Review:</strong> ${formatDateLocalized(
            dealReviewDate,
            dateFormat,
            language
          )} <br />`
        )}
      {recoveryEstimate &&
        ReactHtmlParser(
          `<strong>Recovery Estimate:</strong>  ${recoveryEstimate} <br />`
        )}
      {placement &&
        ReactHtmlParser(`<strong>Placement:</strong> ${placement}<br />`)}
      {exemption &&
        ReactHtmlParser(`<strong>Exemption:</strong> ${exemption}<br />`)}
      {longTermSecurityRating &&
        ReactHtmlParser(
          `<strong>Security LTR:</strong> ${longTermSecurityRating} ${isLongTermSecRatAlertCode} <br />`
        )}
      {shortTermSecurityRating &&
        ReactHtmlParser(
          `<strong>Security STR:</strong> ${shortTermSecurityRating} ${isShortTermSecRatAlertCode} <br />`
        )}
    </>
  )
}
